if (!customElements.get('copy-callouts')) {
  customElements.define('copy-callouts', class CopyCallouts extends HTMLElement {
    constructor() {
      super();
      this.lastKnownScrollPosition = 0;
      this.getContents = this.querySelectorAll('.image-with-text__text.rte p');
      
      document.addEventListener('scroll', () => {
        this.lastKnownScrollPosition = window.scrollY;
        this.highlightText(this.lastKnownScrollPosition);
      });      
    }

     highlightText(scrollPos) {
       let markerPos = this.querySelector('.marker').offsetTop;
       const line =  Math.ceil(markerPos);
    
      this.getContents.forEach((content, index) => {
        let nextItem = null;
        let previousItem = null;
        let isLastItem = true;
        let isFirstItem = true;
          
        if(this.getContents.length - 1 !== index) {
          nextItem = this.getContents[index+1].offsetTop;
          isLastItem = false;
        }
        if(0 !== index) {
          previousItem = this.getContents[index-1].offsetTop + this.getContents[index-1].offsetHeight;
          isFirstItem = false;
        }
        if ((isLastItem && line > previousItem + 30) || (line < nextItem && line > previousItem + 30 ) || (isFirstItem && line < nextItem )){
          if(! content.classList.contains('active-content')) {
            content.classList.add('active-content')
          }
        } else {
          content.classList.remove('active-content')
        }
      })
    }
  });
}
